const ChildrenCategoryDerivationType = {
  PERCENTAGE: 1,
  FIXED: 2
}

export default ChildrenCategoryDerivationType
